var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-pano",attrs:{"id":"panoContainer"}})}
var staticRenderFns = []

export { render, staticRenderFns }